function validateScroll() {
  
  function init() {
    jQuery(window).scroll(validateScroll);
    validateScroll();
  }
  function validateScroll() {
    const top = jQuery(document).scrollTop();
    const classHeaderFixed = 'component-menu-header--fixed';
    if(top > 20) {
      jQuery('.component-menu-header').addClass(classHeaderFixed);
    } else {
      jQuery('.component-menu-header').removeClass(classHeaderFixed);
    }
  }
  init();
}
new validateScroll();
